module.exports = __webpack_public_path__ + "static/media/iphone-1-landing-mobile-en.99319f9a.png";